import Box from "@material-ui/core/Box";
import React from "react";
import {makeStyles, Typography} from "@material-ui/core";
import {useLoading} from "../../../../util/LoadingProvider";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import styled from "styled-components";
import {EventListingTable} from "./components/EventListingTable";
import apiHelper from "../../../../util/ApiHelper";
import {modal} from "../../../../util";
import {EventCategoryListingTable} from "./components/EventCategoryListingTable";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
    background: "#ffffff",
    paddingTop: "10px",
    paddingBottom: "10px",
    minHeight: "800px",
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  button: {
    backgroundColor: "#306F9D",
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "#306F9D",
    },
  },
  pagination: {
    "& .MuiTextField-root": {
      width: "35px",
      minWidth: "auto",
    },
    "& .MuiSelect-root": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
    "& input": {
      padding: "4px 0",
      marginLeft: "10px",
      marginRight: "10px",
    },
    "& button": {
      background: "white",
      color: "#cccccc",
      border: "1px solid #CCCCCC",
      minWidth: "auto",
      width: "24px",
      height: "24px",
      margin: "4px 0",
      "&.left": {
        borderRadius: "4px 0 0 4px",
        marginLeft: "10px",
      },
      "&.right": {
        borderRadius: " 0 4px 4px 0",
      },
    },
  },
  displayAllBtn: {
    textDecoration: "underline",
    color: "#306f9d",
    paddingRight: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

const StatusFilter = styled.ul`
  list-style: none;
  display: inline-flex;
  padding: 0;
  margin-left: 25px;

  li {
    button {
      border: 0;
      background: transparent;
      color: #306f9d;
      font-size: 13px;
      line-height: 15px;
      padding: 0 10px;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #333333;
      }
    }

    &:not(:last-of-type) {
      button {
        border-right: 1px solid black;
      }
    }

    &:first-of-type {
      button {
        padding-left: 0;
      }
    }
  }
`;

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const EventCategoryListingContainer = ({match, disabled}) => {
  const classes = useStyles();
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [keyword, setKeyword] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [displayAll, setDisplayAll] = React.useState(false);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalElements, setTotalElements] = React.useState(0);
  const [status, setStatus] = React.useState(null);
  const {setLoading} = useLoading();

  const statusFilterHandler = (newStatus) => {
    setLoading(true);
    setStatus(newStatus);
    // TODO: wait for api update
    setLoading(false);
  };

  const getEventCategoryListing = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getEventCategoryListing({
        keyword,
        status,
        page,
        rowsPerPage,
      })
      setData(res.data.content)
      setTotalPages(res.data.totalPages)
      setTotalElements(res.data.totalElements)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [keyword, status, page, rowsPerPage, displayAll])

  const singleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete Event",
      text: "Are you sure to delete this event?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        setLoading(true);
        await apiHelper.hkiff.deleteEventCategoryById(id)
        await getEventCategoryListing()
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
    }
  }

  const bulkDelete = async (ids) => {
    const decision = await modal.fire({
      title: "Delete Events",
      text: "Are you sure to delete these events?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        setLoading(true);
        const promises = ids.map(id => apiHelper.hkiff.deleteEventCategoryById(id))
        await Promise.all(promises)
        await getEventCategoryListing()
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
    }
  }

  const getMaxSeqInRows = (rows) => {
    let sequence = null;
    rows.forEach((e) => {
      if (
        (e.sequence && sequence === null) ||
        (sequence !== null && e.sequence > sequence)
      ) {
        sequence = e.sequence;
      }
    });
    return sequence;
  };

  const saveOrdering = async () => {
    try {
      setLoading(true);
      const maxSeq = getMaxSeqInRows(data);
      const seqData = {};
      data.forEach((e, i) => {
        seqData[e.id] = maxSeq - i;
      });
      // TODO - wait for ordering api
      // const result = await apiHelper.hkiff.orderFilmListing(seqData);
      // if (result.data.code === 0) {
      //   toast.dark("Your changes is saved.");
      //   await getEventCategoryListing();
      // }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    void getEventCategoryListing()
  }, [keyword, status, page, rowsPerPage])

  return (
    <>
      <StatusFilter>
        <li>
          <button
            className={status === null ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(null)}
          >
            <Typography variant="p">All</Typography>
          </button>
        </li>
        <li>
          <button
            className={status === true ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(true)}
          >
            <Typography variant="p">
              Active
            </Typography>
          </button>
        </li>
        <li>
          <button
            className={status === false ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(false)}
          >
            <Typography variant="p">
              Inactive
            </Typography>
          </button>
        </li>
      </StatusFilter>
      <EventCategoryListingTable
        match={match}
        disabled={disabled}
        classes={classes}
        data={data}
        setData={setData}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        totalPages={totalPages}
        totalElements={totalElements}
        search={setKeyword}
        singleDelete={singleDelete}
        bulkDelete={bulkDelete}
        saveOrdering={saveOrdering}
        displayAll={displayAll}
        setDisplayAll={setDisplayAll}
      />
    </>
  )

}

const EventListingContainer = ({match, disabled}) => {
  const classes = useStyles();
  const [data, setData] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [keyword, setKeyword] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalElements, setTotalElements] = React.useState(0);
  const [status, setStatus] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState(null);
  const {setLoading} = useLoading();

  const statusFilterHandler = (newStatus) => {
    setLoading(true);
    setStatus(newStatus);
    // TODO: wait for api update
    setLoading(false);
  };

  const getEventListing = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getEventListing({
        keyword,
        status,
        page,
        rowsPerPage,
        categoryId: selectedCategory,
      })
      setData(res.data.content)
      setTotalPages(res.data.totalPages)
      setTotalElements(res.data.totalElements)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [keyword, status, page, rowsPerPage, selectedCategory])

  const getCategories = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getEventCategoryListing({
        unpaged: true,
      })
      setCategories(res.data.content)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [])

  const singleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete Event",
      text: "Are you sure to delete this event?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        setLoading(true);
        await apiHelper.hkiff.deleteEventById(id)
        await getEventListing()
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
    }
  }

  const bulkDelete = async (ids) => {
    const decision = await modal.fire({
      title: "Delete Events",
      text: "Are you sure to delete these events?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        setLoading(true);
        const promises = ids.map(id => apiHelper.hkiff.deleteEventById(id))
        await Promise.all(promises)
        await getEventListing()
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
    }
  }

  React.useEffect(() => {
    void getCategories()
  }, [])

  React.useEffect(() => {
    void getEventListing()
  }, [keyword, status, page, rowsPerPage, selectedCategory])

  return (
    <>
      <StatusFilter>
        <li>
          <button
            className={status === null ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(null)}
          >
            <Typography variant="p">All</Typography>
          </button>
        </li>
        <li>
          <button
            className={status === 1 ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(1)}
          >
            <Typography variant="p">
              Active
            </Typography>
          </button>
        </li>
        <li>
          <button
            className={status === 0 ? "active" : ""}
            type="button"
            onClick={() => statusFilterHandler(0)}
          >
            <Typography variant="p">
              Inactive
            </Typography>
          </button>
        </li>
      </StatusFilter>
      <EventListingTable
        match={match}
        disabled={disabled}
        data={data}
        setData={setData}
        categories={categories}
        classes={classes}
        totalPages={totalPages}
        totalElements={totalElements}
        singleDelete={singleDelete}
        bulkDelete={bulkDelete}
        search={setKeyword}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        filterByCategory={setSelectedCategory}
        refreshData={getEventListing}
      />
    </>
  )
}

export const EventListingPage = ({match, disabled}) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Event
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{
          style: {
            top: "0",
            background: "#306F9D"
          }
        }}
      >
        <Tab label="Manage" {...a11yProps(0)} />
        <Tab
          label="Category" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <EventListingContainer match={match} disabled={disabled}/>
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <EventCategoryListingContainer match={match} disabled={disabled}/>
      </TabPanel>
    </div>
  );
}